import type { IconProps } from './types';

function ComparisonLinkIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M6 6H1V18H15V9M18 18H23V6H9V15" stroke={color} strokeWidth="2" />
    </svg>
  );
}

export { ComparisonLinkIcon };
